import { Link, useNavigate } from 'react-router-dom';
import React from 'react';
import { useSideNavSelectionDispatch } from '../../contexts/sidenavselection';

export const CategoryCard = ({ category }) => {
	const navigate = useNavigate();
	const setSideNavPosition = useSideNavSelectionDispatch();

	const onClick = id => {
		setSideNavPosition({ id: id });
		navigate(`/align/resources/category/${id}/local`);
	};

	return (
		<div
			onClick={() => onClick(category.id)}
			key={category.id}
			className="flex flex-col overflow-hidden rounded-lg shadow-lg my-6 hover:cursor-pointer">
			<div className="flex-shrink-0 bg-gray-100">
				{category.imageUrl ? (
					<img className="h-48 w-full object-cover" src={category.imageUrl} alt="" />
				) : (
					<div className="h-48 w-full object-cover"></div>
				)}
			</div>
			<div className="flex flex-1 flex-row bg-white p-2 rounded-lg border-gray-300 h-16 justify-items-center">
				<span className="px-1 font-semibold text-sm text-gray-600 min-w-full text-center">
					{category.title}
				</span>
			</div>
		</div>
	);
};

export const CategoryCardGlobal = ({ category }) => {
	const navigate = useNavigate();
	const setSideNavPosition = useSideNavSelectionDispatch();

	const onClick = id => {
		setSideNavPosition({ id: id });
		navigate(`/align/resources/category/${id}/global`);
	};

	return (
		<div
			onClick={() => onClick(category.id)}
			key={category.title}
			className="flex flex-col overflow-hidden rounded-lg shadow-lg my-6 hover:cursor-pointer">
			<div className="flex-shrink-0 rounded-lg bg-gray-100">
				{category.imageUrl ? (
					<img className="h-48 w-full object-cover" src={category.imageUrl} alt="" />
				) : (
					<div className="h-48 w-full object-cover"></div>
				)}
			</div>
			<div className="flex flex-1 flex-row bg-white p-2  h-16 justify-items-center">
				<span className="px-1 font-semibold text-sm text-gray-600 min-w-full text-center">
					{category.title}
				</span>
			</div>
		</div>
	);
};
